export default "__VITE_ASSET__DihdCIkE__"